import styled from "styled-components";

export const BigGradientText = styled.h1`
  text-align: top;
  font-size: 4rem;
  background: linear-gradient(#eebd89, #d13abd);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const CenterText = styled.div`
  height: 15vh;
  display: grid;
  place-items: center;
`;